export const INTEGRATION_NAME = 'VercelAI';
